export default __webpack_public_path__ + "static/media/gallery_02.d30e52f3.jpg";